import { ApplicationConfig, provideBrowserGlobalErrorListeners } from '@angular/core';
import { provideRouter } from '@angular/router';
import { TitleStrategy } from '@angular/router';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideToastr } from 'ngx-toastr';
import { provideQuillConfig } from 'ngx-quill';

import { routes } from './app.routes';
import { authInterceptor } from './interceptors/auth.interceptor';
import { AppTitleStrategy } from './services/title.service';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideRouter(routes),
    provideHttpClient(withInterceptors([authInterceptor])),
    provideAnimations(),
    provideToastr(),
    // Toolbar tuned for service-agreement authoring: headings, emphasis, lists,
    // links. Images/embeds are intentionally excluded — the snapshot model
    // stores raw HTML and we don't want to embed base64 blobs.
    provideQuillConfig({
      modules: {
        toolbar: [
          [{ header: [1, 2, 3, false] }],
          ['bold', 'italic', 'underline'],
          [{ list: 'ordered' }, { list: 'bullet' }],
          ['blockquote'],
          ['link'],
          ['clean'],
        ],
      },
    }),
    { provide: TitleStrategy, useClass: AppTitleStrategy },
  ],
};
